<template>
<div v-if="user.merchant">
    <kt-row>
        <kt-col xs="12" sm="6">
            <kt-form-group>
                <kt-form-label for="birth_crtfct_number">
                    {{ $t('label.birth_crtfct_number') }}
                </kt-form-label>
                <kt-form-control dir="ltr" :value="user.merchant.birth_crtfct_number" name="birth_crtfct_number" id="birth_crtfct_number" disabled></kt-form-control>
            </kt-form-group>
        </kt-col>
        <kt-col xs="12" sm="6">
            <kt-form-group>
                <kt-form-label for="national_code">
                    {{ $t('label.national_code') }}
                </kt-form-label>
                <kt-form-control dir="ltr" :value="user.merchant.national_code" name="national_code" id="national_code" disabled></kt-form-control>
            </kt-form-group>
        </kt-col>


        <kt-col xs="12" sm="6">
            <kt-form-group>
                <kt-form-label for="gender">
                    {{ $t('label.gender') }}
                </kt-form-label>
                <kt-form-control :value="user.merchant.gender" name="gender" id="gender" disabled></kt-form-control>
            </kt-form-group>
        </kt-col>
        <kt-col xs="12" sm="6">
            <kt-form-group>
                <kt-form-label for="birth_date">
                    {{ $t('label.birth_date') }}
                </kt-form-label>
                <kt-form-control dir="ltr" :value="user.merchant.birth_date" name="birth_date" id="birth_date" disabled></kt-form-control>
            </kt-form-group>
        </kt-col>


        <kt-col xs="12" sm="6">
            <kt-form-group>
                <kt-form-label for="first_name_fa">
                    {{ $t('label.first_name_fa') }}
                </kt-form-label>
                <kt-form-control :value="user.merchant.first_name_fa" name="first_name_fa" id="first_name_fa" disabled></kt-form-control>
            </kt-form-group>
        </kt-col>
        <kt-col xs="12" sm="6">
            <kt-form-group>
                <kt-form-label for="first_name_en">
                    {{ $t('label.first_name_en') }}
                </kt-form-label>
                <kt-form-control dir="ltr" :value="user.merchant.first_name_en" name="first_name_en" id="first_name_en" disabled></kt-form-control>
            </kt-form-group>
        </kt-col>


        <kt-col xs="12" sm="6">
            <kt-form-group>
                <kt-form-label for="last_name_fa">
                    {{ $t('label.last_name_fa') }}
                </kt-form-label>
                <kt-form-control :value="user.merchant.last_name_fa" name="last_name_fa" id="last_name_fa" disabled></kt-form-control>
            </kt-form-group>
        </kt-col>
        <kt-col xs="12" sm="6">
            <kt-form-group>
                <kt-form-label for="last_name_en">
                    {{ $t('label.last_name_en') }}
                </kt-form-label>
                <kt-form-control dir="ltr" :value="user.merchant.last_name_en" name="last_name_en" id="last_name_en" disabled></kt-form-control>
            </kt-form-group>
        </kt-col>


        <kt-col xs="12" sm="6">
            <kt-form-group>
                <kt-form-label for="father_name_fa">
                    {{ $t('label.father_name_fa') }}
                </kt-form-label>
                <kt-form-control :value="user.merchant.father_name_fa" name="father_name_fa" id="father_name_fa" disabled></kt-form-control>
            </kt-form-group>
        </kt-col>
        <kt-col xs="12" sm="6">
            <kt-form-group>
                <kt-form-label for="father_name_en">
                    {{ $t('label.father_name_en') }}
                </kt-form-label>
                <kt-form-control dir="ltr" :value="user.merchant.father_name_en" name="father_name_en" id="father_name_en" disabled></kt-form-control>
            </kt-form-group>
        </kt-col>


        <kt-col xs="12" sm="4">
            <kt-form-group>
                <kt-form-label for="birth_crtfct_series_letter">
                    {{ $t('label.birth_crtfct_series_letter') }}
                </kt-form-label>
                <kt-form-control dir="ltr" :value="user.merchant.birth_crtfct_series_letter" name="birth_crtfct_series_letter" id="birth_crtfct_series_letter" disabled></kt-form-control>
            </kt-form-group>
        </kt-col>
        <kt-col xs="12" sm="4">
            <kt-form-group>
                <kt-form-label for="birth_crtfct_series_number">
                    {{ $t('label.birth_crtfct_series_number') }}
                </kt-form-label>
                <kt-form-control dir="ltr" :value="user.merchant.birth_crtfct_series_number" name="birth_crtfct_series_number" id="birth_crtfct_series_number" disabled></kt-form-control>
            </kt-form-group>
        </kt-col>
        <kt-col xs="12" sm="4">
            <kt-form-group>
                <kt-form-label for="birth_crtfct_serial">
                    {{ $t('label.birth_crtfct_serial') }}
                </kt-form-label>
                <kt-form-control dir="ltr" :value="user.merchant.birth_crtfct_serial" name="birth_crtfct_serial" id="birth_crtfct_serial" disabled></kt-form-control>
            </kt-form-group>
        </kt-col>
    </kt-row>
    <kt-row>
        <kt-col v-if="user.merchant.requests.length > 0">
            <kt-table is_responsive>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>{{ $t('label.status') }}</th>
                        <th>{{ $t('label.type') }}</th>
                        <th>{{ $t('label.response_thacking_number') }}</th>
                        <th>{{ $t('label.response_success') }}</th>
                        <th>{{ $t('label.response_rejection_reason') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-bind:key="index" v-for="(request, index) in user.merchant.requests">
                        <td>{{ request.id }}</td>
                        <td>{{ shRequestStatusStr.get(request.status) }}</td>
                        <!-- <td>{{ shRequestTypeStr.get(request.type) }}</td> -->
                        <td>{{ request.type }}</td>
                        <td>{{ request.response_tracking_number }}</td>
                        <td>{{ shSuccessRequest(request.response_success) }}</td>
                        <td v-bind:key="rindex" 
                        v-for="(rejection, rindex) in request.response_rejection_reason">
                            <span>{{ rejection.codeExceptionValue }} : {{ rejection.fieldName }}</span>
                        </td>
                        <td v-if="request.response_rejection_reason.length == 0"></td>
                    </tr>
                </tbody>
            </kt-table>
        </kt-col>
        <kt-col v-else class="mb-4">
            <p class="badge badge-warning w-100 p-3 text-dark" style="font-size:1.2em">
                {{ $t('not_sent_request_to_shaparak_yet') }}
            </p>
        </kt-col>
    </kt-row>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { shRequestStatusStr } from '@/constants/shaparakRequestStatus'
import { shRequestTypeStr } from '@/constants/shaparakRequestType'

export default {
    computed: {
        ...mapGetters('user', [
            'user'
        ]),
        shRequestStatusStr() {
            return shRequestStatusStr
        },
    },
    methods: {
        shSuccessRequest(response_success) {
            return response_success == 1 ? this.$t('label.yes') : this.$t('label.no')
        },
        createMerchantRequest(e) {
        }
    },
    mounted() {

    }
}
</script>

<style>
</style>